import type { CellContext } from '@tanstack/vue-table';
import { h } from 'vue';
import PaymentStatus from './PaymentStatus.vue';

export const GetStatusRenderer = (enumOptions: any) => {
  return (info: CellContext<any, any>) =>
    h(PaymentStatus, {
      key: `${info.row.original.id}-${info.row.original.status_display}-${info.row.original.is_clarification_requested}`,
      info,
      enumOptions,
    });
};
